module.exports = __webpack_public_path__ + "static/media/gitlab.e5137aba.svg";